import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Filters from "./containers/Filters";
import ListView from "./containers/ListView";
import ListViewToolbar from "./containers/ListViewToolbar";
import TasksProvider, { useTasks } from "./contexts/tasks-context";
import TypesProvider from "./contexts/types-context";
import TemplatesProvider from './contexts/templates-context';
import CurrentUserProvider from "./contexts/current-user-context";
import CategoriesProvider from "./contexts/categories-context";
import SuggestionsProvider from "./contexts/suggestions-context";
import ModalsProvider, { useModals } from "./contexts/modals-context";
import ListViewPagination from "./containers/ListViewPagination";
import { modalTypes } from "./constants";
import queryString from "query-string";

const CareTeamTasks = () => {
  const { openModal } = useModals();
  const { fetchTasks, initializing, queryParams, sortingParams, filters } = useTasks();

  useEffect(() => {
    if (!initializing) {
      fetchTasks();
    }
  }, [initializing, queryParams, sortingParams, filters]);

  useEffect(() => {
    const { task_id: taskId } = queryString.parse(window.location.search);

    if (taskId) {
      openModal(modalTypes.EDIT_TASK_MODAL, { taskId });
    }
  }, []);

  return (
    <div id="care_team_tasks">
      <Filters />
      <ListViewToolbar />
      <ListView />
      <ListViewPagination />
    </div>
  );
};

const CareTeamTasksContainer = ({ types, categories, currentUser, templates, suggestions, ...props }) => (
  <TypesProvider value={types}>
    <CategoriesProvider value={categories}>
      <TemplatesProvider value={templates}>
        <SuggestionsProvider value={suggestions}>
          <CurrentUserProvider value={currentUser}>
            <TasksProvider {...props}>
              <ModalsProvider>
                <CareTeamTasks {...props} />
              </ModalsProvider>
            </TasksProvider>
          </CurrentUserProvider>
        </SuggestionsProvider>
      </TemplatesProvider>
    </CategoriesProvider>
  </TypesProvider>
);

CareTeamTasksContainer.propTypes = {
  types: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  templates: PropTypes.object.isRequired,
  suggestions: PropTypes.object.isRequired
};

export default CareTeamTasksContainer;
